import { styled, ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps, toggleButtonGroupClasses } from "@mui/material";

type ToggleButtonsProps = Omit<ToggleButtonGroupProps, 'color'> & {
    color: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
    options: {
        label: string;
        value: string;
        Icon?: React.ReactNode;
    }[];
};

export default function ToggleButtons({ options, color, ...groupProps }: ToggleButtonsProps) {

    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => {
        const buttonsColor = theme.palette[color].main;
        return {
            [`& button.${toggleButtonGroupClasses.grouped}`]: {
                px: 1.5,
                py: 1,
                borderWidth: 2,
                borderColor: buttonsColor,
                textTransform: 'none',
                gap: theme.spacing(1),
                [`&:not(.${toggleButtonGroupClasses.selected})`]: { // not selected
                    color: buttonsColor,
                    backgroundColor: '#fff',
                },
                [`&.${toggleButtonGroupClasses.selected}`]: { // selected
                    color: '#fff',
                    backgroundColor: buttonsColor,
                },
            },
        };
    });

    return (
        <StyledToggleButtonGroup {...groupProps}>
            {options.map(option => (
                <ToggleButton
                    key={option.value}
                    value={option.value}
                >
                    {option.Icon}
                    {option.label}
                </ToggleButton>
            ))}
        </StyledToggleButtonGroup>
    );
}